import { render, staticRenderFns } from "./LearningContentFormFields.vue?vue&type=template&id=1c57046c"
import script from "./LearningContentFormFields.vue?vue&type=script&lang=js"
export * from "./LearningContentFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports